import { ROUTE } from '@/constants';
import store from '@/store';

const navigationGuard = {
  async setupAuthorization() {
    if (!store.getters['isAuthenticated']) {
      await store.dispatch('initAuth');
    }
    return store.getters['isAuthenticated']
      ? ROUTE.AUTH.USER_ROLE.AUTHORIZED
      : ROUTE.AUTH.USER_ROLE.NOT_AUTHORIZED;
  },
};

export default navigationGuard;
